import React, { useState } from 'react';
import './DemoVideo.scss';
import PlayArrow from '../../UI/Icons/PlayArrow';
import { COLORS } from '../../../constants/colors';

/**
 * Renders demo video component
 * @param {string} source
 * @param {string} poster
 * @param {function} handlePlay
 * @param {number} index
 * @constructor
 */
const DemoVideo = React.forwardRef(({ source, poster, handlePlay, index }, ref) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const onClick = () => {
    if (!isPlaying) {
      setIsPlaying(true);
    } else {
      setIsPlaying(false);
    }
  };

  return (
    <div className="c-demo-video">
      {!isPlaying && (
        <button
          onClick={() => {
            handlePlay(index);
            onClick();
          }}
          className="c-demo-video__play-button"
        >
          <PlayArrow color={COLORS.white} />
        </button>
      )}
      {!isPlaying && <div className="c-demo-video__overlay"></div>}
      <video
        ref={ref}
        className="c-demo-video__source"
        muted={false}
        controls={isPlaying}
        poster={poster}
        src={source}
      >
        <source src={source} />
      </video>
    </div>
  );
});

export default DemoVideo;
